module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menus-body"
  }, [_c('ul', {
    ref: "listaPlatos",
    staticClass: "items custom-scroll",
    attrs: {
      "id": "listaPlatos"
    }
  }, _vm._l((_vm.platosOrdenados), function(plato) {
    return _c('li', {
      key: plato._id,
      staticClass: "item",
      attrs: {
        "data-item": _vm._f("serialized")(plato)
      }
    }, [_c('div', {
      staticClass: "overlay"
    }), _vm._v(" "), _c('div', {
      staticClass: "label-category"
    }, [_c('span', {
      staticClass: "category-name"
    }, [_vm._v(_vm._s(plato.categoria.nombre))]), _vm._v(" "), _c('div', {
      staticClass: "btn-group pull-right"
    }, [_c('router-link', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "to": '/platoform/edit/' + plato._id,
        "title": "Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _vm._m(1, true)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "menus-item-photo",
      style: ({
        backgroundImage: 'url(' + plato.urlThumb + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "menus-item-detail"
    }, [_c('p', {
      staticClass: "menus-item-name"
    }, [_vm._v(_vm._s(plato.nombre))])]), _vm._v(" "), _vm._m(2, true)])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-ghost",
    attrs: {
      "href": "#",
      "title": "Cambiar stock"
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-ghost",
    attrs: {
      "href": "#",
      "title": "Marcar como no publicado"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-stock"
  }, [_c('span', [_vm._v("SIN STOCK")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54885167"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Restaurante/ListaPlatos.vue
// module id = 1128
// module chunks = 5